import React, { useMemo } from 'react';

import FormattedPrice from 'src/shared/components/common/price/FormattedPrice';

import { MenuItem } from 'public/components/default_template/menu_section/MenuSection';
import QuantitySelector from 'public/components/default_template/online_ordering/item_modal/QuantitySelector';
import Breadcrumbs from 'public/components/default_template/product_display/Breadcrumbs';
import { MenuItemImage } from 'public/components/default_template/product_display/MenuItemImage';
import { useModifierContext } from 'public/components/online_ordering/ModifierContext';
import { ModifierGroup } from 'public/components/online_ordering/types';

import { ModifiersSection } from './ModifiersSection';

type Props = {
  menuItem: MenuItem
  modifierGroups: ModifierGroup[]
}

export const ProductDisplay = ({ menuItem, modifierGroups }: Props) => {
  const { price, quantity } = useModifierContext();
  const totalItemPrice = useMemo(() => quantity * price, [quantity, price]);

  return (
    <div className="paddedContent">
      <div className="paddedSection productDisplayBreadcrumbs">
        <Breadcrumbs name={menuItem?.name || ''} />
      </div>
      <div className="paddedSection productDisplaySection">
        {menuItem?.imageUrls &&
        <div className="productImageSection">
          <MenuItemImage item={menuItem} />
        </div>}
        <div className="productInfoSection">
          <h2 className="productNameRow" data-testid="productName">{menuItem.name}</h2>

          {/* TODO show offer price */}
          {/* TODO price doesn't show since menuItemDetails and useOOMenus return different types */}
          <div className="pricesRow">
            {isNaN(quantity) ? '0.00' : <FormattedPrice value={totalItemPrice} />}
          </div>

          <ModifiersSection groups={modifierGroups} />

          <div className="addToCartRow">
            <AddToCart />
            <QuantitySelector min={1} canIncrease={true} onQuantityChange={() => {}} />
          </div>
          <div>
            {menuItem.description}
          </div>
        </div>
      </div>
    </div>
  );
};

const AddToCart = () => {
  return (
    <button
      type="button"
      className="modalButton addToCartButton" style={{ justifyContent: 'center' }}>
        Add to Cart
    </button>
  );
};
